import React, { useContext, useState } from "react";
import "./Search.css";
import SearchIcon from "@mui/icons-material/Search";
import { useHistory } from "react-router";
import { StateContext } from "../context/StateProvider";
import { actionType } from "../context/Reducer";
function Search({ hideButtons = false, userInput = null }) {
  const [input, setInput] = useState("");
  const history = useHistory();
  const [{}, dispatch] = useContext(StateContext);

  function googleSearch(event) {
    event.preventDefault();
    dispatch({
      type: actionType.SET_SEARCH_TERM,
      term: input,
    });
    history.push("/search");
  }

  return (
    <form className="search">
      <div className="search__input">
        <SearchIcon className="search_icon" />
        <input
          value={userInput}
          onChange={(event) => setInput(event.target.value)}
          type="text"
        />
      </div>
      <div className={hideButtons ? "search_lang_hidden" : "buttons_lang"}>
        <div className="search_buttons">
          <button disabled={!input} type="submit" onClick={googleSearch}>
            Google Search
          </button>
          <button disabled={!input}>I'm Feeling Lucky</button>
        </div>
        <div className="search_lang">
          <div>Google offered in: العربية Français</div>
        </div>
      </div>
    </form>
  );
}

export default Search;
